import axios from '../axiosWrapper';

const buyCabinet = {
  /**
   **@disc: 获取机柜购买区域
   **@author: mengln
   */
  getCabinetRegions(params) {
    return axios({
      url: '/api/aidc/getRegions',
      method: 'get',
      params
    })
  },
  /**
   **@disc: 获取用户库存
   **@author: mengln
   */
  getQuota(params) {
    return axios({
      url: '/api/bm/getUserQuotas',
      method: 'get',
      params
    })
  },

  /**
   **@disc: 获取用户实名认真信息
   **@author: mengln
   */
  getRealNameAuthentication(params) {
    return axios({
      url: '/api/user/describePrivilegeNew',
      method: 'get',
      params
    })
  },

  /**
   **@disc:  查询机柜库存
   **@author: mengln
   */
  getCabinetStock(params) {
    return axios({
      url: '/api/aidc/isStockEnough',
      method: 'get',
      params
    })
  },

  /**
   **@disc: 获取机柜规格
   **@author: mengln
   */
  getCabinetSpecs(params) {
    return axios({
      url: '/api/aidc/getCabinetSpecifications',
      method: 'get',
      params
    })
  },

  /**
   **@disc: 计算机柜价格
   **@author: mengln
   */
  getCabinetTotalPrice(params) {
    return axios({
      url: '/api/billing/calculateTotalPrice',
      method: 'get',
      params
    })
  },

  /**
   **@disc: 根据dc查region、clz
   **@author: mengln
   */
  getDataCenter(params) {
    return axios({
      url: '/api/aidc/getDataCenter',
      method: 'get',
      params
    })
  },

  /**
   **@disc: 根据productCode查region、clz、dataCenter
   **@author: mengln
   */
  getCabinetSpecification(params) {
    return axios({
      url: '/api/aidc/getCabinetSpecification',
      method: 'get',
      params
    })
  },

  /**
   **@disc: 创建临时订单
   **@author: mengln
   */
  submitTempOrder(data) {
    return axios({
      url: '/api/buy/addAndSubmitBuy',
      method: 'post',
      data
    })
  }
}

export default buyCabinet




// WEBPACK FOOTER //
// ./src/axiosHandler/buyCabinet/interface.js